//React
import React from "react";
import PropTypes from "prop-types";
//CSS
import "./index.scss";

/**
 * A small status label with a leading dot (ASB-4295, first used by the Bulk
 * Reporting Tool's reports table). The tone picks the colors; the caller owns
 * the wording. Tokens only.
 *
 *   <StatusPill tone="success" label="Ready" />
 */
export const STATUS_PILL_TONES = ["neutral", "info", "success", "error", "muted"];

function StatusPill({ tone, label, className }) {
	return (
		<span className={["status-pill", `status-pill--${tone ?? "neutral"}`, className ?? ""].join(" ").trim()}>
			{label}
		</span>
	);
}

StatusPill.propTypes = {
	/** neutral (waiting), info (in progress), success, error, muted (ended without a result) */
	tone: PropTypes.oneOf(STATUS_PILL_TONES),
	label: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export default StatusPill;
